import Styles from './ImagePickerModal.module.scss'
import { Modal } from 'almanac-ui/Modal'
import { ImagePickerProvider, useImagePickerContext } from './ImagePickerContext'
import { useRef } from 'react'
import { Sidebar } from './Sidebar/Sidebar'
import { Stock } from './Stock/Stock'
import { Uploads } from './Uploads/Uploads'
import { Gifs } from './Gifs/Gifs'
import { Link } from './Link/Link'
import { ImagePickerModalContainerProps, ImagePickerModalProps } from './Types'
import { Stepper } from 'components/Wizards/Stepper/Stepper'
import { AiGeneration } from './AIGeneration/AiGeneration'
import { BrandKits } from 'components/ImagePickerModal/BrandKits/BrandKits'
import { useBrandKits } from 'hooks/queries/brandKits/useBrandKits'

const ImagePickerModal = ({ title = 'Add or Generate Image', steps, step, ...props }: ImagePickerModalProps) => {
  const { provider, onCancel } = useImagePickerContext()
  const headerActionsRef = useRef<HTMLDivElement>(null)
  const { data } = useBrandKits({
    select: (data) => data.filter((brandKit) => brandKit.media_files.length > 0),
    cacheTime: 1000 * 60 * 5,
  })

  return (
    <Modal.Root size="lg" onClose={onCancel} aria-labelledby="picker-header" centered={false} {...props}>
      {steps && steps.length > 0 && (
        <Modal.Top>
          <div className={Styles.top}>
            <Stepper.Root current={step}>
              {steps.map((step, i) => (
                <Stepper.Step key={`${step}_${i}`}>{step}</Stepper.Step>
              ))}
            </Stepper.Root>
          </div>
        </Modal.Top>
      )}
      <Modal.Header
        id="picker-header"
        title={title}
        actions={<div className={Styles.headerActions} ref={headerActionsRef} />}
      />
      <div className={Styles.body}>
        <Sidebar />
        <div className={Styles.main}>
          {provider === 'ai' && <AiGeneration actionsContainerRef={headerActionsRef} />}
          {provider === 'stock' && <Stock actionsContainerRef={headerActionsRef} />}
          {provider === 'uploads' && <Uploads />}
          {provider === 'gifs' && <Gifs actionsContainerRef={headerActionsRef} />}
          {provider === 'link' && <Link actionsContainerRef={headerActionsRef} />}
          {provider === 'brandKits' && (
            <BrandKits actionsContainerRef={headerActionsRef} initialBrandKitId={data?.[0].id || 0} />
          )}
        </div>
      </div>
    </Modal.Root>
  )
}

const ImagePickerModalContainer = ({
  title,
  step = 1,
  steps = [],
  onPressOutside,
  ...props
}: ImagePickerModalContainerProps) => {
  return (
    <ImagePickerProvider {...props}>
      <ImagePickerModal title={title} steps={steps} step={step} onPressOutside={onPressOutside} />
    </ImagePickerProvider>
  )
}

export { ImagePickerModalContainer as ImagePickerModal }
